import { API_BASE_URL } from '../../common/ApiClient';

export const SampleUrl = {
  all: '/samples{?id,valueDate,type,sessionId,page,size,sort*,lockState,dataSubjectName,statusIds*,dataManagerUsername,dataModifiedByUsername,dataModifiedAtFrom,dataModifiedAtTo}',
  upload: '/samples/upload-excel{?id,valueDate,type}',
  deleteAll: '/samples/delete-all{?id,valueDate,type}',
  scopeUsers: '/samples/scope-users{?id,valueDate,type}',
} as const;

export const SampleExcelUrl =
  API_BASE_URL + '/samples/excel{?id,valueDate,type}';
